import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody40';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy40 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Preliminary Deal Assessment </h2><h4>for a private equity firm focused on multi-family real estate</h4>";

  return (
    <>
        <Helmet>
        <title>Preliminary Deal Assessment for a private equity firm focused on multi-family real estate</title>
        <meta property="og:title" content="Preliminary Deal Assessment for a private equity firm focused on multi-family real estate " />
        <meta property='og:description' content='Preliminary Deal Assessment for a private equity firm focused on multi-family real estate '/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy40" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy40
